import './GiLogo.scss';
import template from './GiLogo.vhtml';

export default {
	name: 'GiLogo',
	template: template,
	props: {},
	data: () => ({
		percentage: null,
		dot: null,
		line: null,
		firstAnimation: false,
		secondAnimation: false,
		thirdAnimation: false,
		showLogoText: false,
	}),
	computed: {},
	methods: {},
	mounted() {
		this.firstAnimation = true;
		setTimeout(() => {
			this.secondAnimation = true;
		}, 300);
		setTimeout(() => {
			this.thirdAnimation = true;
		}, 500);
		setTimeout(() => {
			this.showLogoText = true;
		}, 1000);
	},
};
